import {useEventListener} from '@vueuse/core'
import {ref, computed} from 'vue'

/**
 * Use focus composable
 */
export function useFocus(element) {

  //Track if element has focus
  const hasFocus = ref(document.activeElement === (element.value?.$el || element.value))

  //Focus and blur helpers
  const el = computed(() => element.value?.$el || element.value)
  const focus = () => el.value?.focus()
  const blur = () => el.value?.blur()

  //Apply event listeners
  useEventListener(element, 'focus', () => hasFocus.value = true)
  useEventListener(element, 'blur', () => hasFocus.value = false)

  //Return methods
  return {
    focus,
    blur,
  }
}
